import { leftSpout, rightReceptacle, MID_ROW, LAST_ROW, type LevelConfig } from './portHelpers';

/**
 * STEP TWO — three pipes, shuffled on the right wall so every pipe has to
 * crisscross. Pedagogically forces the student to read the tags and route by
 * matching molecule type, not by horizontal alignment.
 *
 *   left O₂   row 2  →  right O₂   row 13   (top-left to bottom-right)
 *   left food row 8  →  right food row 2    (mid-left to top-right)
 *   left CO₂  row 13 →  right CO₂  row 8    (bottom-left to mid-right)
 */
export const LEVEL_2: LevelConfig = {
  step: 2,
  title: 'STEP TWO',
  instructions:
    'Three pipes — match each spout to the right receptacle. Tags tell you which is which.',
  ports: [
    leftSpout('s2-spout-O2', 2, ['oxygen']),
    leftSpout('s2-spout-food', MID_ROW, ['food']),
    leftSpout('s2-spout-CO2', LAST_ROW - 2, ['co2']),
    rightReceptacle('s2-recept-O2', LAST_ROW - 2, ['oxygen']),
    rightReceptacle('s2-recept-food', 2, ['food']),
    rightReceptacle('s2-recept-CO2', MID_ROW, ['co2']),
  ],
};
